export enum GenderType {
    Male = 0,
    Female = 1,
    Other = 2
}

export const GenderTypeLabel: { [key in GenderType]: string } = {
    [GenderType.Male]: 'GENDER_LIST.MALE',
    [GenderType.Female]: 'GENDER_LIST.FEMALE',
    [GenderType.Other]: 'GENDER_LIST.OTHER'
};

export const GenderTypeValue: { [key in GenderType]: string } = {
    [GenderType.Male]: 'M',
    [GenderType.Female]: 'F',
    [GenderType.Other]: 'O'
};